/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Logger, LogService } from '@epg/angular-base-lib';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService, COMPANY_NAME_QUERY_PARAM } from '../../../services/api.service';
import { EPGImageFormat, EPGImageSliderItem } from '../epg-image-slider/epg-image-slider.component';
import { isBase64Image } from '../functions';

export interface ImageSliderItem {
  image: string;
  thumbImage?: string;
  title?: string;
}

export interface ImageSliderSize {
  space?: number;
  width?: number;
  height?: number;
}

interface NgImageSliderItem {
  image: string;
  thumbImage: string;
  title?: string;
}

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  standalone: false
})
export class ImageSliderComponent implements OnChanges {
  @Input() images: ImageSliderItem[] = [];
  @Input() imageSize?: ImageSliderSize;
  @Input() manageImageRatio: boolean = false;
  @Input() displayBorder? = false;
  @Input() stretchToContainer = false;

  @Output() imageClick = new EventEmitter<number>();
  @Output() lightboxClose = new EventEmitter<object>();

  sliderItems: EPGImageSliderItem[] = [];

  private readonly log: Logger;

  constructor(logService: LogService) {
    this.log = logService.getLogger(this);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.images) {
      this.sliderItems = this.images.map((item) => {
        const sliderItem = item as EPGImageSliderItem;

        if (sliderItem.imageFormat === undefined) {
          sliderItem.imageFormat = isBase64Image(sliderItem.image)
            ? EPGImageFormat.BASE64
            : EPGImageFormat.URL;
        }

        if (sliderItem.rotationValue === undefined) {
          sliderItem.rotationValue = 0;
        }

        if (sliderItem.scaleValue === undefined) {
          sliderItem.scaleValue = 1;
        }

        return sliderItem;
      });
    }
  }
}
